import { render, staticRenderFns } from "./BoschPanel.vue?vue&type=template&id=2c7b988e&scoped=true"
import script from "./BoschPanel.vue?vue&type=script&lang=js"
export * from "./BoschPanel.vue?vue&type=script&lang=js"
import style0 from "./BoschPanel.vue?vue&type=style&index=0&id=2c7b988e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7b988e",
  null
  
)

export default component.exports